import { BuildingOfficeOrderSiteMenuList } from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "c64ed846-a6d3-4a3e-b1af-81060a52e038",
    label: "DG(BLDG)'s Office Order No. 06 of 2016-2017",
    date: "08/03/2017",
    subject: "Procedure of Demand of fees and charges through MAS",
  },
  {
    fileStoreId: "640c439a-fdd7-4010-afde-598435889750",
    label: "DG(BLDG)'s Office Order No. 03 of 2016-2017",
    date: "18/10/2016",
    subject:
      "MC Order no 11 of 2016-17 dated 27102016 regarding authentication of Assessment Roall",
  },
  {
    fileStoreId: "3b3a6be4-ce95-4c54-ab9b-49d9a367ec16",
    label: "DG(BLDG)'s Office Order No. 01 of 2016-2017",
    date: "09/09/2016",
    subject: "Rejection of plan case for non-submission of BLRO mutation",
  },
];

const Building_OfficeOreder_2016 = () => (
  <TableStructure
    title="Office Order/ 2016"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2016;
